var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('section', {
    staticClass: "section login-form m-0 pb-0"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.busy,
      "no-wrap": ""
    },
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c('b-spinner', {
          attrs: {
            "label": "Loading..."
          }
        })];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "container-fluid p-0"
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "row h-100 mt-0",
    style: {
      minHeight: `${_vm.containerHeight}px`
    }
  }, [_c('div', {
    staticClass: "col-12 col-md-6 col-lg-5 col-xl-5 p-0 d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "signIn-SignUp-Section pl-lg-5 pl-xl-5 pt-5 pb-5 d-flex flex-column justify-content-center align-items-center",
    class: _vm.signInSignUpRightBorder
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-between",
    staticStyle: {
      "height": "285px",
      "padding-bottom": "8px"
    }
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "w-100 row m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0 text-left d-flex flex-row justify-content-center justify-content-md-end justify-content-lg-start justify-content-xl-start align-items-end"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_c('v-btn', {
    staticClass: "mb-3 mb-md-0 mb-lg-0 mb-xl-0",
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "160"
    },
    on: {
      "click": function ($event) {
        '';
      }
    }
  }, [_vm._v(" Register ")])], 1), _c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_c('v-btn', {
    staticClass: "ml-4 mb-3 mb-md-0 mb-lg-0 mb-xl-0",
    attrs: {
      "rounded": "",
      "outlined": "",
      "large": "",
      "dark": "",
      "color": '#ffffff'
    },
    on: {
      "click": _vm.onPasswdReset
    }
  }, [_vm._v(" Back to Home ")])], 1)], 1)])])])]), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-7 col-xl-7 pl-lg-5 pl-xl-5 p-0 mt-4 mt-lg-0 mt-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start align-items-start align-items-md-center align-items-lg-center align-items-xl-center"
  }, [_vm.form.currentLoginState == _vm.LoginState.LOGIN ? _c('form', {
    staticClass: "form-element form-body p-0",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(2), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    style: {
      color: _vm.form.isInvalid.email ? _vm.invalidFormLabelColor : '#fff'
    }
  }, [_vm._v("Email")]), _c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.validateState('email'),
      "required": "required",
      "autocomplete": "username"
    },
    on: {
      "input": _vm.inputChangeHandler
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-phone-feedback"
    }
  }, [_vm._v(" Email is required ")])], 1)]), _c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "form-group password-input-field"
  }, [_c('label', {
    style: {
      color: _vm.form.isInvalid.password ? _vm.invalidFormLabelColor : '#fff'
    }
  }, [_vm._v("Password")]), _c('b-form-input', {
    attrs: {
      "type": _vm.passwordInputFieldType,
      "state": _vm.validateState('password'),
      "name": "password",
      "required": "required",
      "autocomplete": "current-password"
    },
    on: {
      "input": _vm.inputChangeHandler
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-phone-feedback"
    }
  }, [_vm._v(" Password is required ")]), _c('span', {
    staticClass: "password-icon",
    style: {
      right: _vm.isPasswordUpdated ? '35px' : '10px'
    },
    on: {
      "click": function ($event) {
        _vm.isPasswordTextInputField = !_vm.isPasswordTextInputField;
      }
    }
  }, [!_vm.isPasswordTextInputField ? _c('i', {
    staticClass: "fa fa-eye custom-color"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash custom-color"
  })])], 1)]), _vm.showLLAAgreement ? _c('LlaAgreementWidget', {
    attrs: {
      "llaStatus": _vm.form.iagreeStatus,
      "username": _vm.username,
      "llaColor": '#FFCD00',
      "textColor": '#E6E6E6',
      "llaAgreementStatusHandler": _vm.llaAgreementStatusHandler,
      "llaStatement": '* Your session has expired. To continue using Project Spectrum, you must review and agree to the'
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "row m-0 mb-3 mb-lg-0 mb-xl-0"
  }, [!!_vm.error ? _c('div', {
    staticClass: "col-12 alert alert-danger text-center text-lg-left text-xl-left my-3"
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e(), _c('div', {
    staticClass: "col-sm-12 px-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start align-items-center"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "160"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(" Log In ")]), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "rounded": "",
      "outlined": "",
      "large": "",
      "dark": "",
      "color": '#ffffff'
    },
    on: {
      "click": _vm.onPasswdReset
    }
  }, [_vm._v(" Forgot Password ")])], 1)])])]) : _vm._e(), _vm.form.currentLoginState == _vm.LoginState.SEND_EMAIL_CODE ? _c('form', {
    staticClass: "form-element form-body",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(3), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    style: {
      color: _vm.form.isInvalid.email ? _vm.invalidFormLabelColor : '#fff'
    }
  }, [_vm._v("Email")]), _c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.validateState('email'),
      "required": "required",
      "autocomplete": "username"
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-phone-feedback"
    }
  }, [_vm._v(" Email is required ")])], 1)])]), _c('div', {
    staticClass: "row m-0 mt-3"
  }, [!!_vm.error ? _c('div', {
    staticClass: "col-12 alert alert-danger text-center text-lg-left text-xl-left my-3"
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e(), _c('div', {
    staticClass: "col-sm-12 p-0 d-flex flex-row justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "160"
    },
    on: {
      "click": _vm.sendResetCode
    }
  }, [_vm._v(" Email Code ")]), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "rounded": "",
      "outlined": "",
      "large": "",
      "dark": "",
      "color": '#ffffff'
    },
    on: {
      "click": function ($event) {
        _vm.form.currentLoginState = _vm.LoginState.LOGIN;
      }
    }
  }, [_vm._v(" Back to Log In ")])], 1)])])]) : _vm._e(), _vm.form.currentLoginState == _vm.LoginState.RESET_PASSWORD ? _c('form', {
    staticClass: "form-element form-body",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(4), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    style: {
      color: _vm.form.isInvalid.email ? _vm.invalidFormLabelColor : '#fff'
    }
  }, [_vm._v("Email")]), _c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.validateState('email'),
      "required": "required",
      "autocomplete": "username"
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-phone-feedback"
    }
  }, [_vm._v(" Email is Required ")])], 1)]), _c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    style: {
      color: _vm.form.isInvalid.code ? _vm.invalidFormLabelColor : '#fff'
    }
  }, [_vm._v("Code")]), _c('b-form-input', {
    attrs: {
      "type": "number",
      "state": _vm.validateState('code'),
      "required": "required",
      "autocomplete": "username"
    },
    model: {
      value: _vm.form.code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "code", $$v);
      },
      expression: "form.code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-phone-feedback"
    }
  }, [_vm._v(" Verification Code is Required (sent to your email) ")])], 1)]), _c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "form-group password-input-field"
  }, [_c('label', {
    style: {
      color: _vm.form.isInvalid.password ? _vm.invalidFormLabelColor : '#fff'
    }
  }, [_vm._v("Password")]), _c('b-form-input', {
    attrs: {
      "type": _vm.passwordInputFieldType,
      "state": _vm.validateState('password'),
      "name": "password",
      "required": "required",
      "autocomplete": "current-password"
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  }), !_vm.validateState('password') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.form.password.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Password is required ")]) : _vm._e(), !_vm.$v.form.password.goodPassword ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Must be at least 8 characters and contain a lowercase, uppercase, number and special character. ")]) : _vm._e()]) : _vm._e(), _vm.$v.form.password.goodPassword ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v(" Must be at least 8 characters and contain a lowercase, uppercase, number and special character. ")]) : _vm._e(), _c('span', {
    staticClass: "password-icon",
    style: {
      right: _vm.isPasswordUpdated ? '35px' : '10px'
    },
    on: {
      "click": function ($event) {
        _vm.isPasswordTextInputField = !_vm.isPasswordTextInputField;
      }
    }
  }, [!_vm.isPasswordTextInputField ? _c('i', {
    staticClass: "fa fa-eye custom-color"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash custom-color"
  })])], 1)])]), _c('div', {
    staticClass: "row m-0 mt-3"
  }, [!!_vm.error ? _c('div', {
    staticClass: "col-12 alert alert-danger text-center text-lg-left text-xl-left my-3"
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e(), _c('div', {
    staticClass: "col-sm-12 p-0 d-flex flex-row justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "160"
    },
    on: {
      "click": _vm.passwordreset
    }
  }, [_vm._v(" Reset Password ")])], 1), _c('div', {
    staticClass: "col-sm-12 p-0 d-flex flex-row justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start mt-4"
  }, [_c('b-alert', {
    staticClass: "mt-1",
    attrs: {
      "variant": _vm.dismissableAlertVariant,
      "dismissible": "",
      "fade": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function ($event) {
        _vm.showDismissibleAlert = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.dismissableAlertText) + " ")])], 1)])])]) : _vm._e()])])])])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 row m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start align-items-start"
  }, [_c('div', {
    staticClass: "text-center text-md-left text-lg-left text-xl-left login-header-title text-display"
  }, [_vm._v(" Register ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 row m-0 my-4 my-lg-3 my-xl-3",
    staticStyle: {
      "max-height": "120px"
    }
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start align-items-center"
  }, [_c('div', {
    staticClass: "text-left login-header-text"
  }, [_vm._v(" Don’t have an account? Register to begin your organization’s cyber success journey today ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center section-title"
  }, [_c('h2', {
    staticClass: "text-center text-lg-left text-xl-left text-display"
  }, [_vm._v("Sign In")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center section-title"
  }, [_c('h2', {
    staticClass: "text-center text-lg-left text-xl-left text-display"
  }, [_vm._v("Password Reset")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center section-title"
  }, [_c('h2', {
    staticClass: "text-center text-lg-left text-xl-left text-display"
  }, [_vm._v("Password Reset")])]);

}]

export { render, staticRenderFns }